// extracted by mini-css-extract-plugin
export var wrapper = "landing-list-module--wrapper--qmKp7";
export var list = "landing-list-module--list--WDSYX";
export var listLenght3 = "landing-list-module--list-lenght-3--jvdSX";
export var listLenght4 = "landing-list-module--list-lenght-4--VAylY";
export var description = "landing-list-module--description---1dw9";